import React from 'react';
import Header from '../../components/header';
import HeaderBackButton from '../../components/header-back-button';
import { TextEditorMobileToolbar } from '../../components/styled-text-editor';
import { PostPublishButton } from '../publish-button';

const PostEditPageHeader = () =>
  <Header
    left={<HeaderBackButton/>}
    right={<PostPublishButton text="post-edit-page-header.update" formName="post"/>}
    menu={<TextEditorMobileToolbar identifier="post"/>}
  />;

export default PostEditPageHeader;



// WEBPACK FOOTER //
// ./app/containers/post-edit-page-header/post-edit-page-header.js